// Logo Rolling Animation on Scroll
document.addEventListener("DOMContentLoaded", function () {
  const logos = document.querySelectorAll(".header-logo img");
  let lastScrollY = 0;
  let totalRotation = 0;
  let ticking = false;

  function updateLogoRotation() {
    const currentScrollY = window.scrollY;
    const scrollDelta = currentScrollY - lastScrollY;

    // Calculate rotation based on scroll distance
    // Adjust the divisor to control rotation speed (lower = faster)
    const rotationDelta = (scrollDelta / 2) * 1;
    totalRotation += rotationDelta;

    // Apply rotation to all logos
    logos.forEach((logo) => {
      logo.style.transform = `rotate(${totalRotation}deg)`;
    });

    lastScrollY = currentScrollY;
    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updateLogoRotation);
      ticking = true;
    }
  }

  // Listen to scroll events
  window.addEventListener("scroll", requestTick, { passive: true });

  // Reset on page load
  lastScrollY = window.scrollY;
});
